import { yupResolver } from "@hookform/resolvers/yup";
import { RouteProp, useRoute } from "@react-navigation/native";
import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  LayoutNodeFilterType,
  LayoutNodeInput,
  LayoutNodeType,
} from "@towersystems/roam-common/lib/generated-types";
import { FormProvider, useForm } from "react-hook-form";
import { Colors, Spacings } from "react-native-ui-lib";
import { CategoryListScreen } from "../../../../components/CategoryListScreen";
import { DepartmentListScreen } from "../../../../components/DepartmentListScreen";
import { ModalCloseButton } from "@towersystems/roam-common-native";
import { CreateFilterQuickKeyRootParamList } from "../../../../types";
import { useCreateTile } from "../../../../utilities/layout";
import {
  defaultLayoutNodeInputValues,
  filterNodeInputSchema,
} from "../../../../utilities/layout/constants";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { useThemeProvider } from "@towersystems/roam-common-native";
import { FilterQuickKeyFormProvider } from "../../components/LayoutNodeFilterForm/components";
import { CreateFilterQuickKeyScreen } from "../CreateFilterQuickKeyScreen";
import { ColorPickerScreen } from "../../components/ColorPickerScreen/ColorPickerScreen";
import { GenerateAiIconRootScreen } from "../GenerateAiIconScreens";
import { GenerateIconScreenContext } from "../GenerateAiIconScreens/common";

export function CreateFilterQuickKeyRootScreen() {
  const route =
    useRoute<
      RouteProp<CreateFilterQuickKeyRootParamList, "CreateFilterQuickKeyScreen">
    >();

  const { config } = useCreateTile();

  const Stack = createStackHeaderNavigator<any>();

  const { colors } = useThemeProvider();
  const filterType = route.params?.filter || LayoutNodeFilterType.CATEGORY;

  const methods = useForm<LayoutNodeInput>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: makeDefaultValues(),
    resolver: yupResolver(filterNodeInputSchema),
  });
  const { setValue } = methods;
  function makeDefaultValues() {
    return {
      ...defaultLayoutNodeInputValues,
      ...config,
      type: LayoutNodeType.FILTER,
      filter: {
        type: filterType,
        values: [],
      },
    };
  }
  return (
    <GenerateIconScreenContext.Provider
      value={{
        onSubmit: async (base64Image: string) => {
          const time = new Date().getTime();
          const id = `${time}-${Math.floor(Math.random() * 1000)}`;

          // Pass the generated icon back to the previous screen
          const name = `key-icon-${id}.png`;
          setValue(
            "base64Image",
            {
              base64: base64Image,
              imageName: name,
            },
            {
              shouldDirty: true,
              shouldValidate: true,
            }
          );
        },
      }}
    >
      <FormProvider {...methods}>
        <FilterQuickKeyFormProvider>
          <Stack.Navigator
            screenOptions={{
              cardStyle: { height: "100%", backgroundColor: Colors.surface },
              headerShown: true,
              headerTitleAlign: "center",
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              headerLeftContainerStyle: { paddingLeft: Spacings.s5 },
              headerRightContainerStyle: { paddingRight: Spacings.s5 },
              headerTintColor: colors.text,
              headerStyle: {
                backgroundColor: Colors.surface,
                borderBottomWidth: 1,
                borderBottomColor: Colors.borderColor,
              },
              headerLeft: () => <ModalCloseButton />,
            }}
          >
            <Stack.Screen
              name="CreateFilterQuickKeyScreen"
              component={CreateFilterQuickKeyScreen}
              initialParams={{ filter: filterType }}
              options={{
                title: "",
              }}
            />
            <Stack.Group
              screenOptions={{
                animationEnabled: true,
                headerShown: true,
                headerLeft: () => <ModalCloseButton type="Back" />,
              }}
            >
              <Stack.Screen
                name="CategoryListScreen"
                component={CategoryListScreen}
                options={{ title: "Select Category" }}
              />
              <Stack.Screen
                name="DepartmentListScreen"
                component={DepartmentListScreen}
                options={{ title: "Select Department" }}
              />
              <Stack.Screen
                name="GenerateAiIconRootScreen"
                component={GenerateAiIconRootScreen}
                options={{
                  title: "",
                  headerShown: false,
                }}
              />
              <Stack.Screen
                name="ColorPickerScreen"
                component={ColorPickerScreen}
                options={{
                  title: "",
                }}
              />
            </Stack.Group>
          </Stack.Navigator>
        </FilterQuickKeyFormProvider>
      </FormProvider>
    </GenerateIconScreenContext.Provider>
  );
}
